import axios, { CancelTokenSource } from 'axios'
import qs from 'qs'
import apiClient from '../client'

let listViewCancelToken: CancelTokenSource
let markerViewCancelToken: CancelTokenSource

export const CANCEL_TOKEN_MESSAGE = 'Operation canceled due to new request.'

export type GetListingsRequestType = 'Carousel' | 'ListView' | 'Markers'

const getListings = (
  customerId,
  queryParams,
  requestType?: GetListingsRequestType
) => {
  const client = apiClient(
    process.env.REACT_APP_NESTREADY_SEARCH_API_URL,
    customerId
  )

  // use { arrayFormat: 'brackets' } to send filters with multiple properties (such as property type and status)
  // in a format that Rails will interpret as arrays instead of hashes
  const paramString = qs.stringify(queryParams, { arrayFormat: 'brackets' })

  const cancelTokenSrc = handleCancelTokenByRequestType(requestType)

  return client.get(`/listings/search?${paramString}`, {
    cancelToken: cancelTokenSrc?.token,
  })
}

function handleCancelTokenByRequestType(requestType?: GetListingsRequestType) {
  if (requestType === 'ListView') {
    if (listViewCancelToken) {
      listViewCancelToken.cancel(CANCEL_TOKEN_MESSAGE)
    }
    listViewCancelToken = axios.CancelToken.source()
    return listViewCancelToken
  }
  if (requestType === 'Markers') {
    if (markerViewCancelToken) {
      markerViewCancelToken.cancel(CANCEL_TOKEN_MESSAGE)
    }
    markerViewCancelToken = axios.CancelToken.source()
    return markerViewCancelToken
  }
  return undefined
}

export { getListings }
